<template>
  <div>
    <div>
      <el-row>
        <el-col>
          <el-row>
            <el-col :span="5">
              <el-input placeholder="按号码搜索" size="medium" clearable suffix-icon="el-icon-search"
                v-model.trim="searchCondition.phone"
                @keyup.enter.native="onSearchConditionChanged()"></el-input>
            </el-col>
            <el-col :span="5">
              <el-select placeholder="大学" v-model="searchCondition.universityId" 
                size="medium" class="margin-left-20px">
                <el-option v-for="item in universityList" :key="item.Key" :label="item.Value" :value="item.Key">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="5" class="cs-saleQuery-buttons">
                  <el-button size="medium" type="primary" class="margin-left-20px" @click="onSearchConditionChanged()">搜索</el-button>
                </el-col>
          </el-row>
        </el-col>
      </el-row>
      <hr />
      <el-row class="grid-content">
        <el-col>
          <pagination v-loading="loading" :data="listData" :option="paginationOption" @search="search" @loadData="search"
            @pageSizeChange="pageSizeChange" @currentPageChange="currentPageChange" @additional="onAdditional"></pagination>
        </el-col>
      </el-row>
    </div>
    
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import pagination from "../common/pagination";
import { getUniversities } from "../../service/common.service";
import { getStudyAbroadStudentList } from "../../service/studyAbroad.service";

export default {
  props: {
    isActive: Boolean,
  },
  data() {
    return {
      universityList: [
        {
          Key: "",
          Value: "所有学校",
        },
      ],
      searchCondition: {
        phone: "",
        universityId: "",
      },
      loading: false,
      listData: {},
      pageSize: 20,
      isLoadedData: false,
    };
  },
  components: {
    pagination,
  },
  created() {
    getUniversities().then((result) => {
      if (!!result && result.success) {
        this.universityList = this.universityList.concat(result.data);
      }
    });

    let additionalColumns = [];
    
    additionalColumns.push({
      name: "viewStudentProfile",
      title: "",
      buttonText: "查看个人信息",
    }); 

    additionalColumns.push({
      name: "viewStudyAbroadProfile",
      title: "",
      buttonText: "查看学术信息",
    });

    this.paginationOption = {
      displayPagination: true,
      hasEditButton: false,
      hasAddButton: false,
      hasSearch: false,
      hasDateSearch: false,
      buttonWidth: 100,
      additionalColumns: additionalColumns,
    };
    if (this.isActive) {
      this.search();
    }
  },
  methods: {
    init() {},
    onSearchConditionChanged() {
      this.listData.CurrentPage = 1;
      this.search();
    },
    search(pageData) {
      if (!this.isActive) {
        return;
      }
      let searchData = this.getSearchPageData(pageData);
      this.loadStudentList(searchData);
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getSearchPageData(pageData) {
      if (typeof pageData == "undefined" || pageData == 1) {
        pageData = {
          pageNumber: 1,
        };
      }

      let additionalFilter = {
        universityId: this.searchCondition.universityId,
      };
      let searchData = {
        pageSize: this.pageSize,
        keyWord: this.searchCondition.phone,
        additionalFilter: additionalFilter,
      };
      searchData = $.extend({}, pageData, searchData);
      return searchData;
    },
    loadStudentList(pageData) {
      this.loading = true;
      this.isLoadedData = true;
      getStudyAbroadStudentList(pageData)
        .then((result) => {
          if (result && result.success) {
            this.listData = result.data;
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    onAdditional(name, index, row) {
      if (name == "viewStudentProfile") {
        this.$router.push({
          path: "/studentProfile",
          query: {
            studentId: row.StudentId,
          },
        });
      } else if (name == "viewStudyAbroadProfile") {
        this.$emit("viewStudyAbroadProfile", row.StudentId);
      }
    },
    
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
        this.search();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studentList/studyAbroadStudentList.vue